import { composeAPI } from "../Common/api";
import internetComposition from "./composition";
import { loadAll } from "../Access/api";

export const composedAPI = composeAPI({ loadAll, ...internetComposition });
